import React, { useState } from 'react';
import './Dashboard.css';

function Dashboard() {
  const [energyData, setEnergyData] = useState({
    current: 0,
    monthly: 0,
    yearly: 0
  });

  const handleInputChange = (type, value) => {
    setEnergyData(prev => ({
      ...prev,
      [type]: parseFloat(value) || 0
    }));
  };

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>⚡ Enerji Takip Dashboard</h1>
        <p>Enerji tüketiminizi takip edin ve yönetin</p>
      </div>
      
      <div className="dashboard-content">
        <div className="energy-cards">
          <div className="energy-card">
            <h3>⚡ Anlık Güç</h3>
            <div className="energy-value">
              <div className="real-time-value">
                <span className="value-number">2,450</span>
                <span className="value-unit">kW</span>
              </div>
            </div>
            <div className="energy-trend">
              <span className="trend-indicator">📊</span>
              <span>Gerçek zamanlı izleme</span>
            </div>
          </div>
          
          <div className="energy-card">
            <h3>⚡ Güç Faktörü</h3>
            <div className="energy-value">
              <div className="real-time-value">
                <span className="value-number">0.92</span>
                <span className="value-unit">PF</span>
              </div>
            </div>
            <div className="energy-trend">
              <span className="trend-indicator">✅</span>
              <span>Optimal seviyede</span>
            </div>
          </div>
          
          <div className="energy-card">
            <h3>🔔 Aktif Alarmlar</h3>
            <div className="energy-value">
              <div className="real-time-value">
                <span className="value-number">3</span>
                <span className="value-unit">Alarm</span>
              </div>
            </div>
            <div className="energy-trend">
              <span className="trend-indicator">⚠️</span>
              <span>Kritik seviye aşımı</span>
            </div>
          </div>
          
          <div className="energy-card">
            <h3>📊 Günlük Tüketim</h3>
            <div className="energy-value">
              <div className="real-time-value">
                <span className="value-number">45,230</span>
                <span className="value-unit">kWh</span>
              </div>
            </div>
            <div className="energy-trend">
              <span className="trend-indicator">📈</span>
              <span>+8% dün ile karşılaştırma</span>
            </div>
          </div>
          
          <div className="energy-card">
            <h3>🌐 Bağlı Cihazlar</h3>
            <div className="energy-value">
              <div className="real-time-value">
                <span className="value-number">127</span>
                <span className="value-unit">Cihaz</span>
              </div>
            </div>
            <div className="energy-trend">
              <span className="trend-indicator">🟢</span>
              <span>%98 sağlıklı</span>
            </div>
          </div>
          
          <div className="energy-card">
            <h3>💰 Günlük Maliyet</h3>
            <div className="energy-value">
              <div className="real-time-value">
                <span className="value-number">₺2,847</span>
                <span className="value-unit">TL</span>
              </div>
            </div>
            <div className="energy-trend">
              <span className="trend-indicator">💰</span>
              <span>Birim fiyat: ₺0.63/kWh</span>
            </div>
          </div>
        </div>
        
        <div className="summary-section">
          <div className="summary-card">
            <h2>📊 Sistem Özeti</h2>
            <div className="system-summary">
              <div className="summary-item">
                <span className="summary-label">Toplam Tüketim:</span>
                <span className="summary-value">45,230 kWh</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Ortalama Güç:</span>
                <span className="summary-value">1,885 kW</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Güç Faktörü:</span>
                <span className="summary-value">0.92</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Günlük Maliyet:</span>
                <span className="summary-value">₺2,847</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Aktif Alarm:</span>
                <span className="summary-value alarm">3 Kritik</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Cihaz Durumu:</span>
                <span className="summary-value healthy">%98 Sağlıklı</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
